import React from 'react';
import { ZdsButton, ZdsIcon, ZdsSpinner } from '@zig-design-system/ui-components-react';
export const Submit = ({ field, submitting }) => {
    return (React.createElement("div", { className: `zds-row powermail_fieldwrap_${field.marker}` },
        React.createElement("div", { className: "zds-col" },
            React.createElement(ZdsButton, { style: { width: '100%' }, type: "submit", disabled: submitting },
                field.title,
                submitting ? (React.createElement(ZdsSpinner, { indeterminate: true, style: { height: '1em', '--zds-spinner-color': '#ffffff', marginLeft: '1em' } })) : (React.createElement(ZdsIcon, { name: "arrow-right", library: "fa-thin", className: "zds-margin-left-2" }))))));
};
